import { render } from "./MyProfile.vue?vue&type=template&id=bab0fdd0"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"
script.render = render

export default script